import React, { useState } from "react";
import "../../../assets/css/BookFlight.css";
import "../../../assets/css/Hotel.css";
import imag1 from "../../../assets/img/hotel-banner.jpg";
import { HotelRecentSearches } from "./components/HotelRecentSearches";
import { HotelExplore } from "./components/HotelExplore";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HotelSearchFooter } from "./components/HotelSearchFooter";
import { HotelSearchFormik } from "./components/HotelSearchFormik";

const SearchHotels = ({ queryparams, showModifySearch }) => {
  const [showRoomInfoModal, setShowRoomInfoModal] = useState(false);

  return (
    <>
      <div className="hw-auto--div"></div>
      <div
        className={`hw-hotes-module hw-hotel--widget ${
          queryparams ? "hw-widget--flight__open" : ""
        }`}
        onClick={() => {
          setShowRoomInfoModal(false);
        }}
      >
        <div
          className={`hw-widget--card hw-br--null`}
          data-src={imag1}
          style={{ backgroundImage: `url(${imag1})` }}
        >
          <div className="hw-page--width">
          <HotelSearchFormik
            showRoomInfoModal={showRoomInfoModal}
            setShowRoomInfoModal={setShowRoomInfoModal}
            showModifySearch={showModifySearch}
            queryparams={queryparams}
            showTitle
          />
          </div>
        </div>
        <HotelRecentSearches />
        <HotelExplore />
        <HotelSearchFooter />
      </div>
    </>
  );
};

export default SearchHotels;
